module.exports = __webpack_public_path__ + "static/media/nike-glyphs.3a041f12.ttf";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nike/ruxac/fonts/NikeGlyphs/nike-glyphs.ttf
// module id = 889
// module chunks = 0